import { useState } from "react";
import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import {
  CoreUiComponents,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import defaultStyles from "./PageFooter.module.scss";
import { PrivacyPolicyModal } from "@/components/PrivacyPolicyModal";
import { TermsOfServiceModal } from "@/components/TermsOfServiceModal";

export type PageFooterComponentProps = PlatformComponentProps;

export const PageFooter = ({
  children,
  className,
}: PageFooterComponentProps) => {
  const { t } = useI18nContext();
  const styles = useUiStyles(CoreUiComponents.PageFooter, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreUiComponents.PageFooter);
  const currentYear = new Date().getFullYear();
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("content")}>
        <div className={cn("left")}>
          <button
            onClick={() => setIsPrivacyModalOpen(true)}
            className={cn("link-button")}
          >
            {t("footer.privacyPolicy")}
          </button>{" "}
          •{" "}
          <button
            onClick={() => setIsTermsModalOpen(true)}
            className={cn("link-button")}
          >
            {t("footer.termsOfUse")}
          </button>{" "}
          • {t("footer.siteMap")} • {currentYear}
        </div>
        <div className={cn("right")}>{t("footer.right")}</div>
      </div>
      {children}
      <PrivacyPolicyModal
        open={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
      />
      <TermsOfServiceModal
        open={isTermsModalOpen}
        onClose={() => setIsTermsModalOpen(false)}
      />
    </div>
  );
};
